import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, map, take } from 'rxjs/operators';
import * as AuthSelectors from '../../auth/store/auth.selectors';
import { PermissionService } from '../services/permission.service';

/**
 * Lets only platform staff through (the bare `admin` role — PermissionService.isPlatformStaff).
 *
 * Waits on `rolesResolved`, never on `roles.length`: on a cold load the role claim is still being
 * read off the token, and an empty role set is a legitimate answer that must end in 404 rather
 * than hang.
 */
export const platformStaffGuard: CanActivateFn = () => {
  const router = inject(Router);
  const permissionService = inject(PermissionService);
  return inject(Store)
    .select(AuthSelectors.selectRolesResolved)
    .pipe(
      filter((resolved) => resolved),
      take(1),
      map(() => (permissionService.isPlatformStaff() ? true : router.createUrlTree(['/404'])))
    );
};
